export interface IconData {
  name: string;
  ligatures: string[];
  aliases: string[];
  categories: string[];
  unicode: string;
  id: number;
  className?: string;
  displayName?: string;
}

export interface CategoryGroup {
  name: string;
  icons: IconData[];
}

export function scoreIcon(
  icon: IconData,
  fullTerm: string,
  tokens: string[],
): number {
  const name = icon.name.toLowerCase();
  const aliasStrings = icon.aliases.map((a) => a.toLowerCase());
  const unicode = icon.unicode.toLowerCase();

  if (name === fullTerm) return 100;
  if (aliasStrings.includes(fullTerm)) return 90;
  if (name.startsWith(fullTerm)) return 80;
  if (aliasStrings.some((a) => a.startsWith(fullTerm))) return 70;
  if (tokens.length > 1 && tokens.every((t) => name.includes(t))) return 60;
  if (
    tokens.length > 1 &&
    aliasStrings.some((a) => tokens.every((t) => a.includes(t)))
  )
    return 55;
  if (name.includes(fullTerm)) return 50;
  if (aliasStrings.some((a) => a.includes(fullTerm))) return 40;
  if (unicode.includes(fullTerm)) return 30;

  const nameHits = tokens.filter((t) => name.includes(t)).length;
  const aliasHits =
    aliasStrings.length > 0
      ? Math.max(
          ...aliasStrings.map(
            (a) => tokens.filter((t) => a.includes(t)).length,
          ),
        )
      : 0;
  const bestHits = Math.max(nameHits, aliasHits);
  if (bestHits > 0 && bestHits >= tokens.length * 0.5) return 10 + bestHits;

  return 0;
}
